// extracted by mini-css-extract-plugin
export default {"impressum":"Impressum_impressum__dLa7K","impressumContainer":"Impressum_impressumContainer__D5ljz","impressumHeadline":"Impressum_impressumHeadline__wOcnV"};